import { ToolTipOptionOutput } from './tool-tip-option-output.model';


export class ToolTipHeaderSelectWithStatus implements IToolTipHeaderSelectWithStatus {
    /** The auto-generated id of the tool tip header master master */
    tooltip_header_id!: number;
    /** The tool tip header name  with 255 character limit */
    tooltip_header_name!: string;
    /** Manage status of tool tip header. 0 For De-active, 1 For Active */
    status!: number;
    tooltip_option!: ToolTipOptionOutput[];

    constructor(data?: IToolTipHeaderSelectWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tooltip_header_id = _data["tooltip_header_id"];
            this.tooltip_header_name = _data["tooltip_header_name"];
            this.status = _data["status"];
            if (Array.isArray(_data["tooltip_option"])) {
                this.tooltip_option = [] as any;
                for (let item of _data["tooltip_option"])
                    this.tooltip_option!.push(ToolTipOptionOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ToolTipHeaderSelectWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ToolTipHeaderSelectWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tooltip_header_id"] = this.tooltip_header_id;
        data["tooltip_header_name"] = this.tooltip_header_name;
        data["status"] = this.status;
        if (Array.isArray(this.tooltip_option)) {
            data["tooltip_option"] = [];
            for (let item of this.tooltip_option)
                data["tooltip_option"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IToolTipHeaderSelectWithStatus {
    /** The auto-generated id of the tool tip header master master */
    tooltip_header_id: number;
    /** The tool tip header name  with 255 character limit */
    tooltip_header_name: string;
    /** Manage status of tool tip header. 0 For De-active, 1 For Active */
    status: number;
    tooltip_option: ToolTipOptionOutput[];
}

